import React from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider, useSelector } from "react-redux";

import { ConfigProvider } from "antd";
import { ToastContainer } from "react-toastify";

import { store } from "./app.store";

import Layout from "./layout";
import Login from "./pages/login";
import Home from "./pages/home";
import OpenCheck from "./pages/opencheck";
import OpenCheckCreate from "./pages/opencheck/openchecklist.create";
import OpenCheckUpdate from "./pages/opencheck/openchecklist.update";
import HotholdCheck from "./pages/hothold";
import HotholdCheckCreate from "./pages/hothold/hotholdchecklist.create";
import HotholdCheckUpdate from "./pages/hothold/hotholdchecklist.update";
import WeeklyCheck from "./pages/weekly";
import WeeklyCheckCreate from "./pages/weekly/weeklychecklist.create";
import WeeklyCheckUpdate from "./pages/weekly/weeklychecklist.update";

import MonthlyCheck from "./pages/monthly";  
import MonthlyCheckCreate from "./pages/monthly/monthlychecklist.create";  
import MonthlyCheckUpdate from "./pages/monthly/monthlychecklist.update"; 

import Delivery from "./pages/delivery";
import Restaurant from "./pages/restaurant";
import RestaurantCreatePage from "./pages/restaurant/restaurant.create";
import RestaurantEditPage from "./pages/restaurant/restaurant.edit";
//import Client from "./pages/client";
import CloseCheck from "./pages/closecheck";
import CloseCheckCreate from "./pages/closecheck/closechecklist.create";
import CloseCheckUpdate from "./pages/closecheck/closechecklist.update";
import Temperatures from "./pages/temperatures";
import TemperaturesEdit from "./pages/temperatures/temperatures.edit";
import TemperatureView from "./pages/temperatures/temperature.view";
import Incident from "./pages/incident";
import IncidentCreate from "./pages/incident/incident.create";
import Reports from "./pages/reports";
import AllergyCheck from "./pages/allergycheck";
import AllergyCreate from "./pages/allergycheck/allergy.create";
import AllergyEdit from "./pages/allergycheck/allergy.edit";
import AllergyEditNew from "./pages/allergycheck/allergy.edit.new";
import Team from "./pages/team";
import TeamView from "./pages/team/team.view";
import Settings from "./pages/settings";

import "./css/app.css";
import "./css/responsive.css";
import "react-quill/dist/quill.snow.css";

import { SocketIOProvider } from "./provider/socketprovider";
import { TimezoneProvider } from "./provider/timezoneprovider";
import { Week } from "react-big-calendar";
import HotholdcheckUpdate from "./pages/hothold/hotholdchecklist.update";
import SupplierPage from "./pages/supplier";
import Compliance from "./pages/compliance";
import ComplianceChecklistCreate from "./pages/compliance/compliance.checklist.create";
import ComplianceChecklistEditPage from "./pages/compliance/compliance.checklist.edit";
import ComplianceChecklistView from "./pages/compliance/compliance.checklist.view";
import ComplianceList from "./pages/compliance/compliance.view";

import Categories from "./pages/label/Categories";
import CategoryProducts from "./pages/label/CategoryProducts";
import FoodDateLabel from "./pages/label/FoodDateLabel";
import PrintQueue from "./pages/label/PrintQueue";
import AllergenManagement from "./pages/label/AllergenManagement";
import ProductDetails from "./pages/label/ProductDetails";
import ProductForm from "./pages/label/ProductForm";
import UsageDashboard from "./pages/usage/UsageDashboard";

const PrivateRoute = ({ children }) => {
  const isAuth = useSelector((state) => state.app.isAuth);
  return isAuth ? children : <Navigate to="/login" />;
};

const App = () => {
  return (
    <Provider store={store}>
      <ConfigProvider>
        <SocketIOProvider>
          <TimezoneProvider>
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="*"
                  element={
                    <PrivateRoute>
                      <Layout>
                        <Routes>
                          <Route path="home" element={<Home />} />
                          <Route
                            path="provechecks"
                            element={<HotholdCheck />}
                          />
                          <Route
                            path="provechecks/create"
                            element={<HotholdCheckCreate />}
                          />
                          <Route
                            path="provechecks/edit/:id"
                            element={<HotholdcheckUpdate />}
                          />
                          <Route
                            path="weeklychecks"
                            element={<WeeklyCheck />}
                          />
                          <Route
                            path="weeklychecks/create"
                            element={<WeeklyCheckCreate />}
                          />
                          <Route
                            path="weeklychecks/edit/:id"
                            element={<WeeklyCheckUpdate />}
                          />

                          <Route
                            path="monthlychecks"
                            element={<MonthlyCheck />}
                          />
                          <Route
                            path="monthlychecks/create"
                            element={<MonthlyCheckCreate />}
                          />
                          <Route
                            path="monthlychecks/edit/:id"
                            element={<MonthlyCheckUpdate />}
                          />

                          <Route path="delivery" element={<Delivery />} />
                          <Route path="supplier" element={<SupplierPage />} />
                          <Route path="openchecks" element={<OpenCheck />} />
                          <Route
                            path="openchecks/create"
                            element={<OpenCheckCreate />}
                          />
                          <Route
                            path="openchecks/edit/:id"
                            element={<OpenCheckUpdate />}
                          />
                          <Route path="restaurant" element={<Restaurant />} />
                          <Route
                            path="restaurant/create"
                            element={<RestaurantCreatePage />}
                          />
                          <Route
                            path="restaurant/:id"
                            element={<RestaurantEditPage />}
                          />
                          {/* <Route path="clients" element={<Client />} /> */}
                          <Route path="closechecks" element={<CloseCheck />} />
                          <Route
                            path="closechecks/create"
                            element={<CloseCheckCreate />}
                          />
                          <Route
                            path="closechecks/edit/:id"
                            element={<CloseCheckUpdate />}
                          />
                          <Route
                            path="temperatures"
                            element={<Temperatures />}
                          />
                          <Route
                            path="temperatures/edit/:id"
                            element={<TemperaturesEdit />}
                          />
                          <Route
                            path="temperatures/view/:id"
                            element={<TemperatureView />}
                          />
                          <Route path="team" element={<Team />} />
                          <Route path="team/view/:id" element={<TeamView />} />
                          <Route path="incidents" element={<Incident />} />
                          <Route
                            path="incidents/create"
                            element={<IncidentCreate />}
                          />
                          <Route path="reports" element={<Reports />} />
                          <Route path="allergy" element={<AllergyCheck />} />
                          <Route
                            path="allergy/create"
                            element={<AllergyCreate />}
                          />
                          <Route
                            path="allergy/edit"
                            element={<AllergyEdit />}
                          />
                          <Route
                            path="allergy/edit/new"
                            element={<AllergyEditNew />}
                          />
                          <Route
                            path="allergy/edit/new/:id"
                            element={<AllergyEditNew />}
                          />
                          <Route path="settings" element={<Settings />} />

<Route path="label/category" element={<Categories />} />
<Route path="label/category/:id/products" element={<CategoryProducts />} />
<Route path="label/food-date-label" element={<FoodDateLabel />} />
<Route path="label/print-queue" element={<PrintQueue />} />
<Route path="label/allergens" element={<AllergenManagement />} />
<Route path="label/product/:id" element={<ProductDetails />} />
<Route path="label/product/:id/edit" element={<ProductForm />} />

<Route path="/owner/usage" element={<UsageDashboard />} />
                          

                          <Route path="compliance" element={<Compliance />} />
                          <Route
                            path="compliance/create/:type"
                            element={<ComplianceChecklistCreate />}
                          />
                          <Route
                            path="compliance/edit/:id"
                            element={<ComplianceChecklistEditPage />}
                          />
                          <Route
                            path="compliance_checks/checklist/:type"
                            element={<ComplianceChecklistView />}
                          />
                          <Route
                            path="compliance_checks"
                            element={<ComplianceList />}
                          />
                          {/* Redirect any unknown routes to home */}
                          <Route path="*" element={<Navigate to="/home" />} />
                        </Routes>
                      </Layout>
                    </PrivateRoute>
                  }
                />
              </Routes>
            </Router>
          </TimezoneProvider>
          <ToastContainer />
        </SocketIOProvider>
      </ConfigProvider>
    </Provider>
  );
};

export default App;
